import React from "react";
import UnifiedProfile from "../component/UnifiedProfile";

const BuyerProfile = () => {
    return (
        <div className="buyer-profile-container">
            <UnifiedProfile role="user" />
        </div>
    );
};

export default BuyerProfile;
